import { BasicClient } from '@/utils/httpClient'

export default class SichernIntegration {
  client: BasicClient
  constructor() {
    this.client = new BasicClient()
  }
  checkIntegrationSichernPeopleByType(type) {
    return Promise.resolve({ data: { data: { enabled: false } } })
  }
  getCountries() {
    return this.client.exec('/externalapis/sichernpeople/countries', 'GET')
  }
  getStates(idCountry) {
    return this.client.exec(
      `/externalapis/sichernpeople/states/${idCountry}`,
      'GET'
    )
  }
  getCities(params) {
    return this.client.exec(
      `/externalapis/sichernpeople/cities/${params.idCountry}/${params.idState}`,
      'GET'
    )
  }
  getMaritalstatus() {
    return this.client.exec('/externalapis/sichernpeople/maritalstatus', 'GET')
  }
  getAddressTypes() {
    return this.client.exec('/externalapis/sichernpeople/addresstypes', 'GET')
  }
  getNationalities() {
    return this.client.exec('/externalapis/sichernpeople/nationalities', 'GET')
  }
  getSichernPeopleOrganizationModel() {
    return this.client.exec(
      '/externalapis/sichernpeople/organizationmodels',
      'GET'
    )
  }
  getCounties(params) {
    return this.client.exec(
      `/externalapis/sichernpeople/counties/${params.idState}`,
      'GET'
    )
  }
  getVia() {
    return this.client.exec('/externalapis/sichernpeople/via', 'GET')
  }
  getZone() {
    return this.client.exec('/externalapis/sichernpeople/zone-type', 'GET')
  }
  getPayrollStatus() {
    return Promise.resolve({ data: { data: { activate: false } } })
  }
  updatePayrollStatus(allowSalaryAdvance:boolean) {
    const status = allowSalaryAdvance ? 1 : 0;
    return this.client.exec('/externalapis/sichernpeople/payroll/salary-advance/status', 'PATCH',  { activated: status })
  }
  getIntegrations() {
    return this.client.exec(
      '/externalapis/integrations',
      'GET'
    )
  }
}
